import React from "react";
import { Table } from "antd";
import Utils from "../../../../utility/Utils";

const SiReportTable = ({ tableData, loading }) => {
  const columns = [
    {
      title: "Customer Name",
      dataIndex: "customer_details",
      key: "customer_details",
      render: (text, record) => {
        return text ? text.firstname + " " + text.lastname : "NA";
      },
    },
    {
      title: "Customer Contact",
      dataIndex: "customer_contact_details",
      key: "customer_contact_details",
      render: (text, record) => {
        return text ? text[0].contact : "NA";
      },
      width: 100,
    },
    {
      title: "Customer Address",
      dataIndex: "customer_contact_address_details",
      key: "customer_contact_address_details",
      render: (text, record) => {
        return text ? text[0].address : "NA";
      },
      width: 100,
    },
    {
      title: "SI Name",
      dataIndex: "si_details",
      key: "si_details",
      render: (text, record) => {
        return text ? text.firstname + " " + text.lastname : "NA";
      },
    },
    {
      title: "SI Contact",
      dataIndex: "si_contact_details",
      key: "si_contact_details",
      render: (text, record) => {
        return text ? text[0].contact : "NA";
      },
    },
    {
      title: "Gateway Sr No",
      dataIndex: "gateway_serial_number",
      key: "gateway_serial_number",
      render: (text, record) => {
        return text ? text : "NA";
      },
    },
    {
      title: "Installation Start Time",
      dataIndex: "start_time",
      key: "start_time",
      render: (text, record) => (text ? Utils.istTime(text) : "NA"),
    },
    {
      title: "Installation End Time",
      dataIndex: "end_time",
      key: "end_time",

      render: (text, record) => (text ? Utils.istTime(text) : "NA"),
    },
    {
      title: "Total Installation Time In Hours",
      dataIndex: "total_hours",
      key: "total_hours",
      render: (text, record) => {
        return text ? Math.floor(text * 100) / 100 + " hours" : "NA";
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={tableData}
      className="report-table"
      size="small"
      pagination={{ defaultPageSize: 50 }}
      scroll={{ x: "max-content", y: "50vh" }}
      loading={loading}
    />
  );
};

export default SiReportTable;
